import { render, staticRenderFns } from "./callbacks-table.vue?vue&type=template&id=cf1d0fcc&scoped=true"
import script from "./callbacks-table.vue?vue&type=script&lang=js"
export * from "./callbacks-table.vue?vue&type=script&lang=js"
import style0 from "./callbacks-table.vue?vue&type=style&index=0&id=cf1d0fcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1d0fcc",
  null
  
)

export default component.exports